import Container from '@/components/atoms/Container'
import Spinner from '@/components/atoms/Spinner'
import { CardMentoring } from '@/components/molecules/Admin/Cards/CardMentoring'
import { Empty } from '@/components/molecules/Admin/Empty'
import { checkDate } from '@/hooks/useCheckDate'
import mentorshipsService from '@/services/mentorshipsService'
import mentorsService from '@/services/mentorsService'
import { modalCreators } from '@/store/ducks/modal'
import { useAppDispatch } from '@/store/hooks'
import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

export function Mentoring() {
	const navigate = useNavigate()

	const { data: dataMentorships, isLoading } = mentorshipsService.list()

	const { execute: attendMentorship } = mentorshipsService.attendMentorship()

	const [mentorshipOld, setMentorshipOld] = useState<{
		mentorshipId: string
		date: string
	}>()

	const [cardClick, setCardClick] = useState<number>()

	const {
		execute: getMentor,
		data,
		isLoading: isLoadingGetMentor,
		isSuccess,
	} = mentorsService.getMutation()

	const {
		execute: getAviabilitiesMentor,
		data: dataAviabilities,
		isLoading: isLoadingAviabilities,
		isSuccess: isSuccessAviabilities,
	} = mentorsService.getAviabilities()

	const dispatch = useAppDispatch()

	useEffect(() => {
		if (isSuccess && isSuccessAviabilities) {
			dispatch(modalCreators.closeModal())

			if (!mentorshipOld?.mentorshipId || !mentorshipOld?.date) {
				dispatch(
					modalCreators.openModal({
						name: 'statusModal',
						type: 'error',
						modalInfo: {
							title: 'Erro na mentoria',
							buttonLabel: 'Fechar',
							message: 'Erro ao tentar remarcar sua mentoria.',
						},
					})
				)
				return
			}

			if (
				!data?.calendar[['EMPREENDA']?.includes(data?.tag || '') ? 60 : 30]
					?.length ||
				!dataAviabilities?.length
			) {
				dispatch(
					modalCreators.openModal({
						name: 'statusModal',
						type: 'error',
						modalInfo: {
							title: 'Mentor indisponível',
							buttonLabel: 'Fechar',
							message:
								'Esse mentor não possui horário disponível, por favor, atualize a página e selecione outro.',
						},
					})
				)
				return
			}

			dispatch(
				modalCreators.openModal({
					name: 'scheduleMentorshipModal',
					modalInfo: {
						reschedule: true,
						mentorshipId: mentorshipOld.mentorshipId,
						dateMentorshipOld: mentorshipOld.date,
						currentSessionDuration: ['EMPREENDA']?.includes(data?.tag || '')
							? 60
							: 30,
						...data,
						availabilities: dataAviabilities,
					},
				})
			)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isSuccess, isSuccessAviabilities])

	const reschedule = ({
		mentorSlug,
		mentorshipId,
		date,
	}: {
		mentorSlug: string
		mentorshipId: string
		date: string
	}) => {
		setMentorshipOld({ mentorshipId, date })
		getMentor({ mentorSlug })
		getAviabilitiesMentor({
			mentorSlug,
			mentorshipId,
		})
	}

	return (
		<div className='w-full pt-10 pb-8'>
			<Container>
				<div className='flex flex-col gap-8'>
					<div className='flex flex-col gap-1'>
						<h1 className='text-2xl text-zinc-50 font-medium'>
							Minhas Mentorias
						</h1>
						<h3 className='text-base text-white/70'>
							Confira abaixo suas sessões de mentoria agendadas
						</h3>
					</div>

					{(() => {
						if (isLoading) {
							return (
								<div className='flex justify-center'>
									<Spinner
										className={
											'inline w-10 h-10 text-gray-200 animate-spin fill-brand-primary'
										}
									/>
								</div>
							)
						}

						if (dataMentorships?.mentorships?.length) {
							return (
								<div className='grid sm:grid-cols-2 xl:flex flex-col gap-3 w-full max-w-[1020px]'>
									{dataMentorships?.mentorships?.map((mentorship, key) => {
										const isNotEditable = mentorship.notEditable

										const disableSelect =
											dayjs(mentorship.date)
												.subtract(1, 'hours')
												.isBefore(dayjs()) || isNotEditable

										const {
											isHappening: mentoringIsHappening,
											inThePast: mentoringInThePast,
										} = checkDate(mentorship.date, 15, 45)

										return (
											<CardMentoring
												isLoading={
													(isLoadingGetMentor || isLoadingAviabilities) &&
													cardClick === key
												}
												mentorship={mentorship}
												mentoringIsHappening={mentoringIsHappening}
												mentoringInThePast={mentoringInThePast}
												options={[
													{
														onClick: () => {
															if (mentorship?.id) {
																navigate(`/mentoria/${mentorship?.id}`)
																return
															}
														},
														// roles: user?.mentor,
														label: 'Detalhes',
													},
													{
														onClick: () => {
															setCardClick(key)
															if (mentoringInThePast) return

															if (!mentorship?.id) {
																modalCreators.openModal({
																	name: 'statusModal',
																	type: 'error',
																	modalInfo: {
																		title: `Erro em mentoria`,
																		buttonLabel: 'Fechar',
																		message: `Erro ao tentar acessar a mentoria.`,
																	},
																})
																return
															}

															window.open(
																mentorship.calendarEventLink,
																'_blank'
															)
															attendMentorship({
																mentorshipId: mentorship?.id?.toString(),
															})
														},
														label: 'Acessar sala',
														disabled: !mentoringIsHappening ? true : false,
														roles: true,
														className: !mentoringIsHappening
															? 'opacity-40'
															: '',
													},
													{
														onClick: () => {
															setCardClick(key)
															if (mentoringInThePast) return

															if (disableSelect) {
																dispatch(
																	modalCreators.openModal({
																		name: 'statusModal',
																		type: 'error',
																		modalInfo: {
																			title: `Remarcar mentoria`,
																			buttonLabel: 'Fechar',
																			message: `Você só pode remarcar uma mentoria até 1 hora antes do horário marcado.`,
																		},
																	})
																)
																return
															}

															reschedule({
																mentorSlug: mentorship.slug,
																mentorshipId: mentorship.id.toString(),
																date: mentorship.date,
															})
														},
														label: 'Remarcar',
														roles: true,
														className: disableSelect ? 'opacity-40' : '',
													},
													{
														onClick: () => {
															setCardClick(key)
															if (mentoringInThePast) return

															if (disableSelect) {
																dispatch(
																	modalCreators.openModal({
																		name: 'statusModal',
																		type: 'error',
																		modalInfo: {
																			title: `Cancelar mentoria`,
																			buttonLabel: 'Fechar',
																			message: `Você só pode cancelar uma mentoria até 1 hora antes do horário marcado.`,
																		},
																	})
																)
																return
															}

															dispatch(
																modalCreators.openModal({
																	name: 'cancelMentorshipModal',
																	modalInfo: {
																		mentorshipId: mentorship?.id || undefined,
																	},
																})
															)
														},
														label: 'Cancelar',
														roles: true,
														className: disableSelect ? 'opacity-40' : '',
													},
												]}
												key={key}
											/>
										)
									})}
								</div>
							)
						}

						return (
							<div className='flex flex-col'>
								<Empty
									title='Você ainda não possui nenhuma sessão agendada'
									image='/imgs/admin/courses/empty-mentors.png'
									link={{
										text: 'Confira nossos mentores abaixo e agende sua sessão',
									}}
								/>
							</div>
						)
					})()}
				</div>
			</Container>
		</div>
	)
}
